export const AppBannerFlagFly = ({ flip = false }) => {
  return (
    <div style={{ width: 15, height: 14, position: 'relative' }}>
      <div
        style={{
          width: 15,
          height: 20,
          background: 'linear-gradient(90deg, #A51328 0%, #910E21 100%)',
          clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 30% 50%)',
          transform: flip ? 'scale(-1, 1)' : null,
        }}
      />
    </div>
  )
}
